module.exports = __webpack_public_path__ + "img/weberror.7336d70d.png";